import React, { useState } from 'react';
import './BottomSheetModal.css';
import { Notification } from "../../../../components/ToastNotification";

const BottomSheetModal = ({ visible, onClose, allCoupons, setAppliedCoupon, isPremiumPlus }) => {
  const [couponCode, setCouponCode] = useState('');

  if (!visible) return null;

  // console.log("all", allCoupons); 
  // console.log("is premium", isPremiumPlus);

  const premium = isPremiumPlus ?  "PremiumPlus": "Premium";
  
  

  const handleApply = () => {
    if (!couponCode) return;

    const foundCoupon = allCoupons?.find(
      (coupon) => coupon.couponText === couponCode && coupon.couponFor === premium
    );

    if (foundCoupon) {
      setAppliedCoupon(foundCoupon);
      setCouponCode("")
      onClose(); 
    } else {
      Notification("Enter Valid Coupon", "error");
      setCouponCode("")
    }
  };

  return (
    <div className="csm-backdrop">
      <div className="bs-overlay" onClick={onClose} />
      <div className="bs-container">
        <div className="bs-handle" />
        <button className="bs-close-btn" onClick={onClose}>✕</button>
        <h2 className="bs-title">APPLY COUPON CODE</h2>

        <div className="bs-input-wrapper">
          <input
            className="bs-input"
            type="text"
            placeholder="Enter Coupon Code"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
          />
        </div>

        <button
          className={`bs-apply-btn ${!couponCode ? 'disabled' : ''}`}
          onClick={handleApply}
          disabled={!couponCode}
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default BottomSheetModal;
